import {
    AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2, TemplateRef, ViewChild
} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {MatStepper} from '@angular/material/stepper';
import {Router} from '@angular/router';
import {AuthService} from '../auth.service';
import {DashboardService, MatToolbarInterface} from '../dashboard.service';
import {AccountVerificationService} from '../account-verification.service';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import {TimerService} from '../timer.service';
import {StepperObserverService} from '../stepper-observer.service';
import {TimeUnits} from '../timer.enums';
import {TimeUtils} from '../time.utils';
import {TimeVisibility} from '../time.visibility.enum';
import {StepAdditional, StepFnItem} from '../step.additional.interface';
import {ValidatorsService} from '../services/validators.service';
import {Subscription} from 'rxjs';
import {AppUtils} from '../app-utils';
import {Location} from '@angular/common';
import {AppTitleService} from '../app-title.service';
import {HttpErrorResponse, HttpStatusCode} from '@angular/common/http';
import {animate, style, transition, trigger} from '@angular/animations';
import {getUserId} from '../consts/utilities';

@Component({
    selector: 'app-link-account',
    templateUrl: './link-account.component.html',
    styleUrls: ['./link-account.component.scss'],
    providers: [{
        provide: STEPPER_GLOBAL_OPTIONS,
        useValue: {showError: true}
    }],
    animations: [
        trigger('fadeSlideInOut', [
            transition(':enter', [
                style({opacity: 0, transform: 'translateY(80px)'}),
                animate('300ms', style({opacity: 1, transform: 'translateY(0)'})),
            ]),
            transition(':leave', [
                animate('300ms', style({opacity: 0, transform: 'translateY(80px)'})),
            ]),
        ])
    ]
})
export class LinkAccountComponent implements OnInit, OnDestroy, AfterViewInit {

    private subscriptions: Subscription[] = [];

    verificationIndex = 2;
    onlinkIndex = 1;
    userType = 'T';
    accountType = 'email';
    canResendTimer = true;
    sendingCode = false;

    userSelectedLinkType = false;
    checkingCode = false;
    wrongCodeError = false;
    verificationCompleted = false;
    linkProcessComplete = false;
    onLastStep = false;

    pwdVisibility = false;

    @ViewChild('serverErrorModal', {static: true})
    serverErrorModal: TemplateRef<any>;

    @ViewChild('resultModal', {static: true})
    resultModal: TemplateRef<any>;

    @ViewChild('accountTypeModal', {static: true})
    accountTypeModal: TemplateRef<any>;

    @ViewChild('stepper', {static: false})
    stepper: MatStepper;

    @ViewChild('timer', {static: true})
    timer: ElementRef<any>;

    linkAccountForm: FormGroup;
    validationForm: FormGroup;

    // Save link account result to show in modals
    result: any;

    categoria = new FormControl('', [Validators.required]);
    lada = new FormControl('52', [Validators.required]);
    tipo = new FormControl('titular', [Validators.required]);
    nombre = new FormControl('', [Validators.required, Validators.maxLength(35)]);
    pap_paterno = new FormControl('', [Validators.required, Validators.maxLength(20)]);
    pap_materno = new FormControl('', [Validators.required, Validators.maxLength(20)]);

    usuario = new FormControl('', [Validators.required, Validators.maxLength(75)]);
    password = new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(24)]);

    // Additional events related to steps in link process
    private events: Map<string, number> =
        new Map<string, number>();
    private additionals: Map<string, StepAdditional> =
        new Map<string, StepAdditional>();

    constructor(
        private dashboardService: DashboardService,
        private authService: AuthService,
        private router: Router,
        private dialog: MatDialog,
        private renderer: Renderer2,
        private timerService: TimerService,
        private location: Location,
        private titleService: AppTitleService,
        private stepperObserverService: StepperObserverService,
        private fb: FormBuilder,
        private validatorService: ValidatorsService,
        private accountVerificationService: AccountVerificationService
    ) {
        this.dashboardService.executeFn$.subscribe(
            action => this.location.back()
        );

        this.titleService.setTitle('Agregar cuenta');
    }

    ngOnInit(): void {
        this.linkAccountForm = this.fb.group({
            account: this.fb.group({
                categoria: this.categoria,
                lada: this.lada,
                usuario: this.usuario,
                password: this.password
            }, {
                validators: [
                    this.validatorService.isValidAccount,
                ],
                asyncValidators: [
                    this.validatorService.linkAccountValidation,
                    this.validatorService.getCountryCode,
                ]
            }),
            additional: this.fb.group({
                tipo_login: this.tipo,
                nombre: this.nombre,
                pap_paterno: this.pap_paterno,
                pap_materno: this.pap_materno,
            })
        });

        this.validationForm = this.fb.group({
            firstDigit: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]],
            secondDigit: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]],
            thirdDigit: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]],
            fourDigit: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]],
            fiveDigit: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]],
            sixDigit: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]]
        });
    }

    ngAfterViewInit(): void {
        // Some steps require to make another calls
        this.registerStepVerificationEvents();
        this.startStepperListener();
        this.checkIfRequirePassField();
        // this.accountTypeListener();
    }

    ngOnDestroy(): void {
        this.stepper.reset();
        // this.timerService.cancel('resend_timer');
        this.subscriptions.forEach((sub: Subscription) => {
            sub.unsubscribe();
        });
    }

    get userHasInsertedName(): boolean {
        const {_, nombre, pap_paterno, pap_materno} = this.linkAccountForm.get('additional').value;

        if (nombre && pap_paterno && pap_materno) {
            return true;
        }

        return false;
    }

    get requirePassInLink(): boolean {
        // tslint:disable-next-line: radix
        return Number.parseInt(sessionStorage.getItem('require_pwd_in_link')) === 1;
    }

    get validUser(): boolean {
        return this.linkAccountForm.get('account').get('usuario').valid;
    }

    get validName(): boolean {
        if (this.userAccountType === 'B') {
            return this.linkAccountForm.get('additional').get('nombre').valid
                && this.linkAccountForm.get('additional').get('pap_paterno').valid;
        }

        return true;
    }

    get validType(): boolean {
        return this.tipo.valid;
    }

    get validPassword(): boolean {
        if (this.requirePassInLink) {
            return this.linkAccountForm.get('account').get('password').valid;
        }

        return true;
    }

    get alreadyAccountExists(): boolean {
        return this.linkAccountForm.get('account').hasError('accountExists');
    }

    get unableToCheckAccount(): boolean {
        return this.linkAccountForm.get('account').hasError('unableToCheckAccount');
    }

    get userAccountType(): string {
        return this.tipo.value.substring(0, 1).toUpperCase();
    }

    get invalidAccount(): boolean {
        return this.linkAccountForm.get('account').hasError('invalidAccount') &&
            this.linkAccountForm.get('account').get('usuario').touched;
    }

    private registerStepVerificationEvents(): void {
        this.events.set('verification', this.verificationIndex);
        this.additionals.set(
            'verification',
            {
                description: 'On verification step',
                fn: [
                    {name: 'verifyLinkedAccount', params: null}
                ],
                passed: this.linkProcessComplete
            }
        );
    }

    private startStepperListener(): void {
        const stepperSub =
            this.stepperObserverService.listen(this.stepper).subscribe(
                (value: { step: number, last: boolean }) => {
                    const {step, last} = value;
                    const search = this.eventSearcher(step, this.events);

                    this.onLastStep = last;

                    if (search != null) {
                        this.eventSearchReturnResult(search);
                    }
                },
                error => console.error('Error en subscriber')
            );

        this.subscriptions.push(stepperSub);
    }

    private eventSearchReturnResult(search: any): void {
        const additional = this.additionals.get(search.name);

        if (!additional.passed) {
            this.runStepEvents(search.name, additional.fn);
        } else {
            console.log(
                `Se detecto una carga de eventos para ${search.name}
                pero ya se ejecuto antes. Por lo tanto se omitio.
                `
            );
        }
    }

    private eventSearcher(
        step: number,
        events: Map<string, number>
    ): { name: string, id: number } | null {

        let result: any = null;

        events.forEach((value: number, key: string) => {
            if (step === value) {
                result = {name: key, id: value};
            }
        });

        return result;
    }

    // Execute assigned functions to step
    private runStepEvents(id: string, fn: StepFnItem[]): void {
        if (fn) {
            for (const func of fn) {
                const {name, params} = func;
                (params !== null) ? this[name](params) : this[name]();
            }

            // Avoid re-run action
            this.additionals.get(id).passed = true;
        }
    }

    cancel(): void {
        this.dialog.closeAll();
    }

    // Make link account request
    private sendLinkAccount(payload: any): void {
        this.authService.createLink(payload).subscribe(
            response => this.openResultDialog(response),
            error => this.openResultDialog(error)
        );
    }

    private openResultDialog(response: any): void {
        const {statusCode, data} = response;

        this.result = data;

        (statusCode === HttpStatusCode.Ok)
            ? this.openLinkResultModal()
            : this.openServerErrorModal();
    }

    private openLinkResultModal(): void {
        this.dialog.open(this.resultModal).afterClosed().subscribe(
            result => {
                this.router.navigate(['dashboard/cards']);
            }
        );
    }

    private openServerErrorModal(): void {
        this.dialog.open(this.serverErrorModal);
    }

    private checkIfRequirePassField(): void {
        if (!this.requirePassInLink) {
            this.linkAccountForm.get('account').get('password').disable();
        }
    }

    private buildLinkPayload(): any {
        let {usuario: user} = this.linkAccountForm.get('account').value;
        const loginType = this.userAccountType;
        const {categoria: category, lada, password} = this.linkAccountForm.get('account').value;
        const {nombre, pap_paterno, pap_materno} = this.linkAccountForm.get('additional').value;

        if (category === 'sms') {
            user = this.getPhoneForSmsOption();
        }

        const payload = {
            usuario: user,
            tipo_login: loginType,
            password,
            nombre,
            ap_paterno: pap_paterno,
            ap_materno: pap_materno
        };

        return payload;
    }

    private onSubmit(): void {
        const payload = this.buildLinkPayload();
        this.sendLinkAccount(payload);
    }

    changeAccountType(type: string): void {
        const validators = (type === 'email')
            ? [Validators.required, Validators.email, Validators.maxLength(75)]
            : [Validators.required, Validators.maxLength(10)];

        this.accountType = type;
        this.userSelectedLinkType = true;

        this.linkAccountForm.get('account').get('usuario').setValidators(validators);
        this.categoria.setValue(type);

        this.stepper.next();
    }

    checkIfATimerCanBeCreated(): void {
        if (this.canResendTimer) {
            this.makeResendCodeTimer();
        } else {
            console.log('Un contador esta activo por el momento. Intente de nuevo al finalizar la cuenta del contador actual.');
        }
    }

    // Start timer to control resend code button state
    makeResendCodeTimer(): void {
        const id = 'resend_timer';
        const seconds: number = TimeUnits.MINUTE * 1;
        const params: any = {id, seconds};
        const timer = this.timerService.create(params);

        this.canResendTimer = false;

        timer.subscribe(value => {
            const {timeLeft, timeOut} = value;
            this.updateResendButtonTimer(timeLeft, timeOut);
        });
    }

    private updateResendButtonTimer(value: number, timeOut: boolean): void {
        (timeOut)
            ? this.enableResendCode()
            : this.updateResendBtnCounterUi(value);
    }

    private enableResendCode(): void {
        this.renderer.setProperty(
            this.timer.nativeElement,
            'innerHTML',
            ``
        );
        this.canResendTimer = true;
    }

    private updateResendBtnCounterUi(value: number): void {
        const date = TimeUtils.getTimeFromSeconds(value);
        const time = TimeUtils.getFixedTime(date, TimeVisibility.FIXED);

        this.renderer.setProperty(
            this.timer.nativeElement,
            'innerHTML',
            `en ${time}`
        );
    }

    // TODO: Begin to listen account verification code input value
    private enableVerificationCodeWatcher(): void {
        this.validationForm.valueChanges.subscribe(value => {
            if (this.validationForm.valid) {
                this.checkingCode = true;
                this.validateCode();
            }
        });
    }

    verifyLinkedAccount(): void {
        let account = this.linkAccountForm.get('account').get('usuario').value;

        if (this.accountType === 'sms') {
            account = this.getPhoneForSmsOption();
        }

        // If sendingCode == true, we need to disable resend
        // button until verification code request is complete.
        this.sendingCode = true;

        this.verifyAccount(account);
    }

    getPhoneForSmsOption(): string {
        const countryCode = this.linkAccountForm.get('account').get('lada').value;
        const user = this.linkAccountForm.get('account').get('usuario').value;
        return `${countryCode}${user}`;
    }

    verifyAccount(account: string): void {
        const id = getUserId();
        this.accountVerificationService.sendLinkCode(id, account)
            .subscribe(
                (response: any) => this.onVerificationResponse(response),
                (error: Error) => this.onVerificationResponse(error)
            );
    }

    onVerificationResponse(response: any): void {
        this.sendingCode = false;

        if (response instanceof HttpErrorResponse) {
            console.error(response);
            return;
        }

        this.onSuccessSendedCode(response);
    }

    onSuccessSendedCode(response: any): void {
        const {statusCode} = response;

        if (statusCode === HttpStatusCode.Ok) {
            this.checkIfATimerCanBeCreated();
            this.enableVerificationCodeWatcher();
        }
    }

    // private clearValidationForm(): void {
    //     this.validationForm.reset();
    //     this.wrongCodeError = false;
    // }

    onPrevStep(): void {
        if (this.stepper.selectedIndex === 1) {
            this.userSelectedLinkType = false;
        }

        this.stepper.previous();
    }

    onNextStep(): void {
        (this.linkProcessComplete) ? this.onSubmit() : this.stepper.next();
    }

    executeCodeValidation(): void {
        this.validateCode();
    }

    // TODO: Make verification code validation request
    public validateCode(): void {
        let account = this.linkAccountForm.get('account').get('usuario').value;

        if (this.accountType === 'sms') {
            account = this.getPhoneForSmsOption();
        }

        let userCode = '';

        Object.values(this.validationForm.controls).forEach(control => {
            userCode += control.value;
        });

        this.accountVerificationService
            .validateVerificationCode(account, userCode, this.accountType).subscribe(
            response => this.onResponseCodeValidation(response),
            error => this.onErrorCodeValidation(error)
        );
    }

    private onResponseCodeValidation(response: any) {
        const {data} = response;
        const {codigo} = data;

        if (codigo !== 0) {
            this.wrongCodeError = true;
            return;
        }

        this.onSuccessCodeValidation(response);
    }

    private onSuccessCodeValidation(response: any): void {
        this.timerService.cancel('resend_timer');
        this.verificationCompleted = true;
        this.linkProcessComplete = true;
        this.registerStepVerificationEvents();
    }

    private onErrorCodeValidation(error: Error): void {
        // Configurar error de codigo verificador en caso de caducar
        // this.codeValidationMessage = error.message;
        // Show error alert
        this.wrongCodeError = true;
    }

    passwordVisibility() {
        // Set password visibility for beneficiary account input
        this.pwdVisibility = !this.pwdVisibility;
    }

    focusOnComplete(event) {
        AppUtils.onDigitInput(event);
    }
}
